import React, { useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { Helmet } from 'react-helmet'
import { selectUserData } from '../../selectors/user'
import useInitialRequest from '../../hooks/initial-request'
import Preloading from '../preloading'
import { selectAppLoadingState } from '../../selectors/app'

export function Auth() {
  useInitialRequest()
  const userData = useSelector(selectUserData)
  const appIsLoading = useSelector(selectAppLoadingState)

  useEffect(() => {
    if (window.Intercom) {
      window.Intercom('boot', {
        app_id: process.env.REACT_APP_INTERCOM_APP_ID,
        email: userData.email,
        name: `${userData.firstname}  ${userData.lastname}`,
        user_id: userData.user_id.toString(),
      })
    }
  }, [userData.user_id])
  return (
    <div>
      {userData.user_id ? (
        <Helmet>
          <script>
            {`
              window.intercomSettings = {
                api_base: "https://api-iam.intercom.io",
                app_id: '${process.env.REACT_APP_INTERCOM_APP_ID}',
                user_id: '${userData.user_id}',
                user_hash: '${userData.intercom_hashes.web_hash}'
              }
            `}
          </script>
          <script>
            {`
              (function(){var w=window;var ic=w.Intercom;if(typeof ic==="function"){ic('reattach_activator');ic('update',w.intercomSettings);}else{var d=document;var i=function(){i.c(arguments);};i.q=[];i.c=function(args){i.q.push(args);};w.Intercom=i;var l=function(){var s=d.createElement('script');s.type='text/javascript';s.async=true;s.src='https://widget.intercom.io/widget/ojnevy62';var x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s,x);};if(document.readyState==='complete'){l();}else if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}}})();
            `}
          </script>
        </Helmet>
      ) : null}
      {appIsLoading ? <Preloading /> : <Outlet />}
    </div>
  )
}
export default Auth

Auth.propTypes = {
}

Auth.defaultProps = {
}
